import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { trpc } from '../lib/trpc';

/**
 * Hook to check setup status and redirect to /setup if needed
 */
export function useSetupCheck() {
  const [, navigate] = useLocation();
  const [checked, setChecked] = useState(false);

  const { data } = trpc.setup.checkStatus.useQuery(undefined, {
    retry: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      if (data.needsSetup && window.location.pathname !== '/setup') {
        navigate('/setup');
      }
      setChecked(true);
    }
  }, [data, navigate]);

  return { needsSetup: data?.needsSetup ?? false, checked };
}
